export const PHONE_NUMBER_ARGENTINA_PATTERN = "^[0-9]{10}$";

export const EMAIL_PATTERN =
  "^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";

export const DNI_PATTERN = "^[1-9][0-9]{6,8}$";
